import React, { useEffect } from 'react';
import { mostrarAgentesSinoEsta } from '../../redux/reducers/agentesReducers';
import {FormControl, InputLabel} from "@mui/material";
import {SelectSmart} from "../CustomTextField";
import Strings from "../../assets/strings";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";

type IProps = {
    required?: boolean
    disabled?: boolean
    margin?: "none" | "dense" | "normal" | undefined
    value?: number
    name?: string
    label?: string
    all?: boolean
    onChange?: any
}

export default function SelectAgente({required,margin="none",value, name="tipo",label= Strings.agentes, all, onChange}:IProps) {

    const dispatch = useAppDispatch();
    const agentes = useAppSelector(state => state.agentes);
    useEffect(() => {
        dispatch(mostrarAgentesSinoEsta())
    }, [dispatch]);


    let options = (agentes.list && agentes.list.map(opc=>({key:opc.id,value: opc.nombre}))) || [];
    options.unshift({key:undefined,value:all?Strings.todo:Strings.seleccione})

    // disabled={options.length <= 1}
    return (
        <FormControl fullWidth required={required} margin={margin} >
            <InputLabel shrink>{label}</InputLabel>
            <SelectSmart
                value={value?.toString() ?? ""}
                onChange={onChange}
                name={name}
                loading={agentes.status === "loading" }
                required={required}
                opciones={options}
            />
        </FormControl>
    );
}
